<template>
	<el-space fill wrap size="large" class="w-100" alignment="stretch">
		<div class="card">
			<div class="card-header">
				<span class="fs-5">Buat Token Aktivasi</span>
			</div>

			<div class="card-body">
				<el-form label-position="top">
					<el-row :gutter="10" align="middle">
						<el-col :xs="24" :sm="7" :xl="6">
							<el-form-item label="Jenis Pengguna" prop="type">
								<el-select v-model="formToken.type" placeholder="Pilih Jenis Pengguna">
									<el-option v-for="t in userTypes" :key="t.paramsType" :label="t.name" :value="t.paramsType" />
								</el-select>
							</el-form-item>
						</el-col>

						<transition name="slide-right" mode="out-in">
							<el-col :xs="24" :sm="6" :xl="4" v-if="formToken.type === 'siswa'">
								<el-form-item label="Rombel" prop="rombel_id">
									<el-select v-model="formToken.rombel_id" filterable placeholder="Pilih Rombel" clearable>
										<el-option v-for="r in listRombel" :key="r.rombel_id" :label="r.nama" :value="r.rombel_id" />
									</el-select>
								</el-form-item>
							</el-col>
						</transition>

						<el-col :xs="24" :sm="11" :xl="10">
							<el-form-item prop="user_presensi_id">
								<template #label>
									<transition name="slide-right" mode="out-in">
										<span :key="formToken.type">{{ userTypes.find((u) => u.paramsType === formToken.type)?.name ?? "Pengguna" }}</span>
									</transition>
								</template>
								<el-select
									v-model="formToken.user_presensi_id"
									filterable
									:placeholder="`Pilih ${userTypes.find((u) => u.paramsType === formToken.type)?.name ?? 'Pengguna'}`"
									clearable
									:disabled="!formToken.type || (formToken.type === 'siswa' && !formToken.rombel_id)">
									<el-option
										v-for="u in listUserPresensiToken(formToken.type)"
										:key="u.user_presensi_id"
										:label="formToken.type === 'siswa' ? `${u.nis} · ${u.nama}` : u.nama"
										:value="u.user_presensi_id" />
								</el-select>
							</el-form-item>
						</el-col>

						<el-col :xs="24" :sm="6" :xl="4">
							<el-form-item label="Masa Berlaku Token" prop="expiration_hours">
								<el-input-number v-model="formToken.expiration_hours" :min="1" :max="240" controls-position="right">
									<template #suffix>
										<span>jam</span>
									</template>
								</el-input-number>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>

				<el-divider border-style="dotted" v-if="generatedToken" />
				<el-descriptions v-if="generatedToken" title="Token Aktivasi Pengguna Terpilih" :column="1" border>
					<template #extra>
						<el-button type="info" plain round @click="generateQRCode(generatedToken)">
							<template #icon>
								<el-icon class="bi bi-qr-code-scan" />
							</template>
							Tampilkan kode QR
						</el-button>
					</template>

					<el-descriptions-item label="Token" class-name="text-break">{{ generatedToken }}</el-descriptions-item>
					<el-descriptions-item label="Waktu Kedaluwarsa">{{ toWIB(tokenExpiresAt) }}</el-descriptions-item>
				</el-descriptions>

				<div v-if="generatedTokens.length">
					<el-divider border-style="dotted" />
					<el-descriptions title="Token Aktivasi Jenis Pengguna Terpilih">
						<template #extra>
							<el-button type="danger" plain round @click="exportPdf">
								<template #icon>
									<el-icon class="bi bi-filetype-pdf" />
								</template>
								Unduh Token Aktivasi
							</el-button>
						</template>
					</el-descriptions>
					<el-table
						:data="generatedTokens"
						table-layout="auto"
						border
						stripe
						v-loading="generatingTokenBatch"
						:header-cell-style="{ background: 'var(--el-fill-color-light)' }"
						class="shadow-sm">
						<el-table-column type="index" label="No." align="center" />
						<el-table-column label="Nama" prop="nama" header-align="center" />
						<el-table-column label="ID Presensi" prop="user_presensi_id" align="center" />
						<el-table-column label="Token Aktivasi" prop="token" align="center" class-name="text-break" :min-width="200" />
						<el-table-column label="Waktu Kedaluwarsa" prop="expires_at" align="center">
							<template #default="{ row }">
								{{ toWIB(row.expires_at) }}
							</template>
						</el-table-column>
						<el-table-column label="Kode QR" align="center">
							<template #default="{ row }">
								<el-tooltip content="Tampilkan kode QR">
									<el-button type="info" plain round @click="generateQRCode(row.token)">
										<template #icon>
											<el-icon class="bi bi-qr-code-scan" />
										</template>
									</el-button>
								</el-tooltip>
							</template>
						</el-table-column>
					</el-table>
				</div>

				<div class="row row-cols-auto g-2 justify-content-end mt-3">
					<el-button
						@click="generateTokenBatch"
						round
						type="info"
						:loading="generatingTokenBatch"
						:disabled="!formToken.type || (formToken.type === 'siswa' && !formToken.rombel_id)">
						<template #icon>
							<el-icon class="bi bi-people-fill" />
						</template>
						Buat Token Semua
						{{ userTypes.find((t) => t.paramsType === formToken.type)?.name ?? "Pengguna" }}
						{{ listRombel.find((r) => r.rombel_id === formToken.rombel_id)?.nama }}
					</el-button>
					<el-button @click="generateToken" round type="primary" :loading="generatingToken" :disabled="!formToken.user_presensi_id">
						<template #icon>
							<el-icon class="bi bi-person-fill" />
						</template>
						Buat Token
					</el-button>
				</div>
			</div>
		</div>

		<el-dialog v-model="qrDialogVisible" align-center width="auto">
			<template #header>Pindai Kode QR Tautan Aktivasi</template>
			<div class="text-center">
				<img :src="qrActivationUrl" alt="" />
			</div>
		</el-dialog>

		<div class="card">
			<div class="card-header">
				<span class="fs-5">Uji Coba Notifikasi</span>
			</div>

			<div class="card-body">
				<el-form label-position="top">
					<el-row :gutter="10" align="top">
						<el-col :xs="24" :sm="7" :xl="6">
							<el-form-item label="Jenis Pengguna" prop="type">
								<el-select v-model="formTestNotify.type" placeholder="Pilih Jenis Pengguna">
									<el-option v-for="t in userTypes" :key="t.bodyType" :label="t.name" :value="t.bodyType" />
								</el-select>
							</el-form-item>
						</el-col>

						<transition name="slide-right" mode="out-in">
							<el-col :xs="24" :sm="6" :xl="4" v-if="formTestNotify.type === 'siswa'">
								<el-form-item label="Rombel" prop="rombel_id">
									<el-select v-model="formTestNotify.rombel_id" filterable placeholder="Pilih Rombel" clearable>
										<el-option v-for="r in listRombel" :key="r.rombel_id" :label="r.nama" :value="r.rombel_id" />
									</el-select>
								</el-form-item>
							</el-col>
						</transition>

						<el-col :xs="24" :sm="11" :xl="10">
							<el-form-item prop="user_presensi_id">
								<template #label>
									<transition name="slide-right" mode="out-in">
										<span :key="formTestNotify.type">{{ userTypes.find((u) => u.paramsType === formTestNotify.type)?.name ?? "Pengguna" }}</span>
									</transition>
								</template>
								<el-select
									v-model="formTestNotify.user_presensi_id"
									filterable
									:placeholder="`Pilih ${userTypes.find((u) => u.paramsType === formTestNotify.type)?.name ?? 'Pengguna'}`"
									clearable
									:disabled="!formTestNotify.type || (formTestNotify.type === 'siswa' && !formTestNotify.rombel_id)">
									<el-option
										v-for="u in listUserPresensiNotify(formTestNotify.type)"
										:key="u.user_presensi_id"
										:label="formTestNotify.type === 'siswa' ? `${u.nis} · ${u.nama}` : u.nama"
										:value="u.user_presensi_id" />
								</el-select>
							</el-form-item>
						</el-col>

						<el-col :xs="24" :sm="8" :xl="6">
							<el-form-item label="Perangkat Tujuan" prop="push_subscription_id">
								<el-select v-model="formTestNotify.push_subscription_id" placeholder="Pilih Perangkat Tujuan" :disabled="!formTestNotify.user_presensi_id">
									<el-option v-for="p in pushSubscriptions" :key="p.push_subscription_id" :label="`${p.push_subscription_id} · ${p.device_label}`" :value="p.push_subscription_id">
										<div class="device-option">
											<div class="device-label">{{ `${p.push_subscription_id} · ${p.device_label}` }}</div>
											<div class="subscription-detail">
												Registrasi awal: <em>{{ toWIB(p.created_at) }}</em>
												<br />
												Diperbarui: <em>{{ toWIB(p.updated_at) || "-" }}</em>
											</div>
										</div>
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="8" :xl="6">
							<el-form-item label="Judul Notifikasi" prop="title">
								<el-input v-model="formTestNotify.title" placeholder="Isi Judul Notifikasi" :disabled="!formTestNotify.push_subscription_id" />
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="8" :xl="6">
							<el-form-item label="Pesan Notifikasi" prop="body">
								<el-input v-model="formTestNotify.body" placeholder="Isi Pesan Notifikasi" :rows="2" type="textarea" :disabled="!formTestNotify.push_subscription_id" />
							</el-form-item>
						</el-col>
					</el-row>
					<div class="text-end">
						<el-button
							@click="sendTestNotification"
							round
							type="success"
							:loading="sendingNotification"
							:disabled="!formTestNotify.type || !formTestNotify.push_subscription_id || !formTestNotify.title || !formTestNotify.body">
							<template #icon>
								<el-icon class="bi bi-send-plus-fill" />
							</template>
							Kirim Notifikasi
						</el-button>
					</div>
				</el-form>
			</div>
		</div>
	</el-space>
</template>

<script>
import QRCode from "qrcode";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
export default {
	name: "AktivasiView",
	data() {
		return {
			userTypes: [
				{ name: "Guru", paramsType: "guru", bodyType: "guru" },
				{ name: "Tenaga Kependidikan", paramsType: "karyawan", bodyType: "karyawan" },
				{ name: "Siswa", paramsType: "siswa", bodyType: "siswa" },
				{ name: "Non-GTK", paramsType: "non-gtk", bodyType: "non_gtk" },
			],
			listUserPresensiGuru: [],
			listUserPresensiKaryawan: [],
			listUserPresensiNonGtk: [],
			listRombel: [],
			listUserPresensiSiswaToken: [],
			listUserPresensiSiswaNotify: [],
			formToken: {
				type: null,
				rombel_id: null,
				user_presensi_id: null,
				expiration_hours: 24,
			},
			generatedToken: null,
			tokenExpiresAt: null,
			generatedTokens: [],
			formTestNotify: {
				type: null,
				rombel_id: null,
				user_presensi_id: null,
				push_subscription_id: null,
				title: "Info Presensi SKAPSA",
				body: "Uji coba pengiriman notifikasi dari server berhasil.",
			},
			pushSubscriptions: [],
			generatingToken: false,
			generatingTokenBatch: false,
			loadingPushSubscription: false,
			sendingNotification: false,
			qrDialogVisible: false,
			qrActivationUrl: null,
		};
	},
	computed: {
		semesterAktif() {
			return this.$store.getters.getSemester;
		},
		formTokenClone() {
			return JSON.parse(JSON.stringify(this.formToken));
		},
		formTestNotifyClone() {
			return JSON.parse(JSON.stringify(this.formTestNotify));
		},
	},
	watch: {
		semesterAktif: {
			immediate: true,
			async handler(val) {
				if (val) {
					this.listRombel = await this.getListRombel(val.semester_id);
				}
			},
		},
		formTokenClone: {
			async handler(newVal, oldVal) {
				if (newVal.type !== oldVal.type) {
					this.formToken.rombel_id = null;
					this.formToken.user_presensi_id = null;

					this.generatedToken = null;
					this.tokenExpiresAt = null;
					this.generatedTokens = [];
				}

				if (newVal.rombel_id !== oldVal.rombel_id) {
					this.formToken.user_presensi_id = null;
					this.generatedTokens = [];

					if (newVal.rombel_id) {
						this.listUserPresensiSiswaToken = await this.getListUserPresensi("siswa", newVal.rombel_id);
					} else {
						this.listUserPresensiSiswaToken = [];
					}
				}

				if (newVal.user_presensi_id !== oldVal.user_presensi_id) {
					this.generatedToken = null;
					this.tokenExpiresAt = null;
				}
			},
		},
		formTestNotifyClone: {
			async handler(newVal, oldVal) {
				if (newVal.type !== oldVal.type) {
					this.formTestNotify.rombel_id = null;
					this.formTestNotify.user_presensi_id = null;
				}

				if (newVal.rombel_id !== oldVal.rombel_id) {
					this.formTestNotify.user_presensi_id = null;

					if (newVal.rombel_id) {
						this.listUserPresensiSiswaNotify = await this.getListUserPresensi("siswa", newVal.rombel_id);
					} else {
						this.listUserPresensiSiswaNotify = [];
					}
				}

				if (newVal.user_presensi_id !== oldVal.user_presensi_id) {
					this.formTestNotify.push_subscription_id = null;

					if (newVal.user_presensi_id) {
						await this.getPushSubscriptions(newVal.user_presensi_id);
					} else {
						this.pushSubscriptions = [];
					}
				}
			},
		},
	},
	mounted() {
		this.$ws.main.on("user:inserted", this.insertedUser);
		this.$ws.main.on("user:updated", this.updatedUser);
		this.$ws.main.on("user:deleted", this.deletedUser);
		this.$ws.main.on("subscription:registered", this.registeredSubscription);
		this.$ws.main.on("subscription:target:unsubscribed", this.targetUnsubscribed);
		this.$ws.main.on("subscription:status:updated", this.subscriptionStatusUpdated);
		this.getBaseListUserPresensi();
	},
	beforeUnmount() {
		this.$ws.main.off("user:inserted");
		this.$ws.main.off("user:updated");
		this.$ws.main.off("user:deleted");
		this.$ws.main.off("subscription:registered");
		this.$ws.main.off("subscription:target:unsubscribed");
		this.$ws.main.off("subscription:status:updated");
	},
	methods: {
		toWIB(timeStr) {
			if (!timeStr) return null;

			return new Date(timeStr).toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "medium" });
		},
		insertedUser(data) {
			if (data.type === "guru") {
				const newData = {
					user_presensi_id: data.user_presensi_id,
					guru_id: data.guru_id,
					nama: data.nama,
				};

				const temp = [...this.listUserPresensiGuru];

				temp.push(newData);
				temp.sort((a, b) => {
					return a.nama.localeCompare(b.nama);
				});

				this.listUserPresensiGuru = temp;

				return;
			}

			if (data.type === "karyawan") {
				const newData = {
					user_presensi_id: data.user_presensi_id,
					karyawan_id: data.karyawan_id,
					nama: data.nama,
				};

				const temp = [...this.listUserPresensiKaryawan];

				temp.push(newData);
				temp.sort((a, b) => {
					return a.nama.localeCompare(b.nama);
				});

				this.listUserPresensiKaryawan = temp;

				return;
			}

			if (data.type === "siswa") {
				if (!data.rombel_id) return;

				if (this.formToken.rombel_id === data.rombel_id) {
					const newData = {
						user_presensi_id: data.user_presensi_id,
						siswa_id: data.siswa_id,
						nis: data.nis,
						nama: data.nama,
					};

					const temp = [...this.listUserPresensiSiswaToken];

					temp.push(newData);
					temp.sort((a, b) => {
						return a.nama.localeCompare(b.nama);
					});

					this.listUserPresensiSiswaToken = temp;
				}

				if (this.formTestNotify.rombel_id === data.rombel_id) {
					const newData = {
						user_presensi_id: data.user_presensi_id,
						siswa_id: data.siswa_id,
						nis: data.nis,
						nama: data.nama,
					};

					const temp = [...this.listUserPresensiSiswaNotify];

					temp.push(newData);
					temp.sort((a, b) => {
						return a.nama.localeCompare(b.nama);
					});

					this.listUserPresensiSiswaNotify = temp;
				}

				return;
			}

			if (data.type === "non_gtk") {
				const newData = {
					user_presensi_id: data.user_presensi_id,
					non_gtk_id: data.non_gtk_id,
					nama: data.nama,
				};

				const temp = [...this.listUserPresensiNonGtk];

				temp.push(newData);
				temp.sort((a, b) => {
					return a.nama.localeCompare(b.nama);
				});

				this.listUserPresensiNonGtk = temp;

				return;
			}
		},
		updatedUser(data) {
			if (this.formToken.user_presensi_id === data.old_user_presensi_id) {
				this.formToken.user_presensi_id = data.user_presensi_id;
			}

			this.generatedTokens.forEach((t) => {
				if (t.user_presensi_id === data.old_user_presensi_id) {
					t.user_presensi_id = data.user_presensi_id;
				}
			});

			if (data.type === "guru") {
				this.listUserPresensiGuru.every((u) => {
					if (u.user_presensi_id === data.old_user_presensi_id) {
						u.user_presensi_id = data.user_presensi_id;

						return false;
					}
					return true;
				});

				return;
			}

			if (data.type === "karyawan") {
				this.listUserPresensiKaryawan.every((u) => {
					if (u.user_presensi_id === data.old_user_presensi_id) {
						u.user_presensi_id = data.user_presensi_id;

						return false;
					}
					return true;
				});

				return;
			}

			if (data.type === "siswa") {
				if (!data.rombel_id) return;

				if (this.formToken.rombel_id === data.rombel_id) {
					this.listUserPresensiSiswaToken.every((u) => {
						if (u.user_presensi_id === data.old_user_presensi_id) {
							u.user_presensi_id = data.user_presensi_id;

							return false;
						}
						return true;
					});
				}

				if (this.formTestNotify.rombel_id === data.rombel_id) {
					this.listUserPresensiSiswaNotify.every((u) => {
						if (u.user_presensi_id === data.old_user_presensi_id) {
							u.user_presensi_id = data.user_presensi_id;

							return false;
						}
						return true;
					});
				}

				return;
			}

			if (data.type === "non_gtk") {
				this.listUserPresensiNonGtk.every((u) => {
					if (u.user_presensi_id === data.old_user_presensi_id) {
						u.user_presensi_id = data.user_presensi_id;

						return false;
					}
					return true;
				});

				return;
			}
		},
		deletedUser(data) {
			if (this.formToken.user_presensi_id === data.old_user_presensi_id) {
				this.formToken.user_presensi_id = null;
			}

			const oldTokenIndex = this.generatedTokens.findIndex((u) => u.user_presensi_id === data.old_user_presensi_id);
			if (oldTokenIndex !== -1) this.listUserPresensiGuru.splice(oldTokenIndex, 1);

			if (data.type === "guru") {
				const oldUserIndex = this.listUserPresensiGuru.findIndex((u) => u.user_presensi_id === data.old_user_presensi_id);
				if (oldUserIndex !== -1) this.listUserPresensiGuru.splice(oldUserIndex, 1);

				return;
			}

			if (data.type === "karyawan") {
				const oldUserIndex = this.listUserPresensiKaryawan.findIndex((u) => u.user_presensi_id === data.old_user_presensi_id);
				if (oldUserIndex !== -1) this.listUserPresensiKaryawan.splice(oldUserIndex, 1);

				return;
			}

			if (data.type === "siswa") {
				if (!data.rombel_id) return;

				if (this.formToken.rombel_id === data.rombel_id) {
					const oldUserTokenIndex = this.listUserPresensiSiswaToken.findIndex((u) => u.user_presensi_id === data.old_user_presensi_id);
					if (oldUserTokenIndex !== -1) this.listUserPresensiSiswaToken.splice(oldUserTokenIndex, 1);
				}

				if (this.formTestNotify.rombel_id === data.rombel_id) {
					const oldUserNotifyIndex = this.listUserPresensiSiswaNotify.findIndex((u) => u.user_presensi_id === data.old_user_presensi_id);
					if (oldUserNotifyIndex !== -1) this.listUserPresensiSiswaNotify.splice(oldUserNotifyIndex, 1);
				}

				return;
			}

			if (data.type === "non_gtk") {
				const oldUserIndex = this.listUserPresensiNonGtk.findIndex((u) => u.user_presensi_id === data.old_user_presensi_id);
				if (oldUserIndex !== -1) this.listUserPresensiNonGtk.splice(oldUserIndex, 1);

				return;
			}
		},
		registeredSubscription(data) {
			if (this.formTestNotify.type !== data.type) return;

			if (this.formTestNotify.user_presensi_id !== data.user_presensi_id) return;

			this.pushSubscriptions.push({
				push_subscription_id: data.push_subscription_id,
				device_label: data.device_label,
				created_at: data.created_at,
				updated_at: data.updated_at,
			});
		},
		targetUnsubscribed(data) {
			if (this.formTestNotify.user_presensi_id !== data.user_presensi_id) return;

			const oldIndex = this.pushSubscriptions.findIndex((s) => s.push_subscription_id === data.push_subscription_id);
			if (oldIndex === -1) return;

			this.pushSubscriptions.splice(oldIndex, 1);

			if (this.formTestNotify.push_subscription_id === data.push_subscription_id) {
				this.formTestNotify.push_subscription_id = null;
			}
		},
		subscriptionStatusUpdated(data) {
			if (data.status === "active") return;

			const oldIndex = this.pushSubscriptions.findIndex((s) => s.push_subscription_id === data.push_subscription_id);
			if (oldIndex === -1) return;

			this.pushSubscriptions.splice(oldIndex, 1);

			if (this.formTestNotify.push_subscription_id === data.push_subscription_id) {
				this.formTestNotify.push_subscription_id = null;
			}
		},
		async getBaseListUserPresensi() {
			this.listUserPresensiGuru = await this.getListUserPresensi("guru");
			this.listUserPresensiKaryawan = await this.getListUserPresensi("karyawan");
			this.listUserPresensiNonGtk = await this.getListUserPresensi("non-gtk");
		},
		async getListUserPresensi(type, rombelId = null) {
			try {
				const { data } = await this.$defaultApi.get(`/user/list/${type}`, {
					params: {
						rombel_id: type === "siswa" ? rombelId : undefined,
					},
				});

				return data.data.list_user_presensi;
			} catch (error) {
				console.error(error);
			}
		},
		listUserPresensiToken(type) {
			switch (type) {
				case "guru":
					return this.listUserPresensiGuru;

				case "karyawan":
					return this.listUserPresensiKaryawan;

				case "siswa":
					return this.listUserPresensiSiswaToken;

				case "non-gtk":
					return this.listUserPresensiNonGtk;

				default:
					return [];
			}
		},
		listUserPresensiNotify(type) {
			switch (type) {
				case "guru":
					return this.listUserPresensiGuru;

				case "karyawan":
					return this.listUserPresensiKaryawan;

				case "siswa":
					return this.listUserPresensiSiswaNotify;

				case "non_gtk":
					return this.listUserPresensiNonGtk;

				default:
					return [];
			}
		},
		async getListRombel(semesterId) {
			try {
				const { data } = await this.$defaultApi.get(`/user/list-rombel/${semesterId}`);

				return data.data.list_rombel;
			} catch (error) {
				console.error(error);
			}
		},
		async getPushSubscriptions(userPresensiId) {
			this.loadingPushSubscription = true;
			try {
				const { data } = await this.$defaultApi.get("/push/subscription", {
					params: {
						user_presensi_id: userPresensiId,
					},
				});

				this.pushSubscriptions = data.data.push_subscriptions;
			} catch (error) {
				if (error.response) {
					console.error(error.response.data);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
				this.$notify.warning({
					title: "Perhatian",
					message: error.message,
				});
			} finally {
				setTimeout(() => {
					this.loadingPushSubscription = false;
				}, 500);
			}
		},
		async generateToken() {
			this.generatingToken = true;
			try {
				const { data } = await this.$defaultApi.post("/push/activation-token", {
					user_presensi_id: this.formToken.user_presensi_id,
					expiration_hours: this.formToken.expiration_hours,
				});

				this.generatedToken = data.data.token;
				this.tokenExpiresAt = data.data.expires_at;

				this.$notify.success({
					title: "Berhasil",
					message: data.data.message,
				});
			} catch (error) {
				if (error.response) {
					console.error(error.response.data);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
				this.$notify.warning({
					title: "Perhatian",
					message: error.message,
				});
			} finally {
				setTimeout(() => {
					this.generatingToken = false;
				}, 500);
			}
		},
		async generateTokenBatch() {
			this.generatingTokenBatch = true;
			try {
				const { data } = await this.$defaultApi.post(`/push/activation-token/${this.formToken.type}`, {
					rombel_id: this.formToken.type === "siswa" ? this.formToken.rombel_id : undefined,
					expiration_hours: this.formToken.expiration_hours,
				});

				this.generatedTokens = data.data.generated_tokens;
				this.$notify.success({
					title: "Berhasil",
					message: data.data.message,
				});
			} catch (error) {
				if (error.response) {
					console.error(error.response.data);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
				this.$notify.warning({
					title: "Perhatian",
					message: error.message,
				});
			} finally {
				setTimeout(() => {
					this.generatingTokenBatch = false;
				}, 500);
			}
		},
		async generateQRCode(token) {
			const activationUrl = `https://info-presensi.sitepgri.com/activation/${token}`;
			try {
				const dataUrl = await QRCode.toDataURL(activationUrl, {
					errorCorrectionLevel: "M",
					scale: 4,
				});

				this.qrActivationUrl = dataUrl;
				this.qrDialogVisible = true;
			} catch (err) {
				console.error(err);
			}
		},
		getPdfColumns() {
			const no = {
				header: "No.",
				dataKey: "no",
			};

			const nis = [
				{
					header: "NIS",
					dataKey: "nis",
				},
			];

			const common = [
				{
					header: "Nama",
					dataKey: "nama",
					align: "left",
				},
				{
					header: "ID Presensi",
					dataKey: "user_presensi_id",
				},
				{
					header: "Token Aktivasi",
					dataKey: "token",
					font: "courier",
				},
				{
					header: "Waktu Kedaluwarsa",
					dataKey: "expires_at",
				},
			];

			return [no, ...(this.formToken.type === "siswa" ? nis : []), ...common];
		},
		exportPdf() {
			const columns = this.getPdfColumns();
			const tableColumns = columns.map((col) => ({
				header: col.header,
				dataKey: col.dataKey,
			}));

			const doc = new jsPDF({
				orientation: "landscape",
				unit: "mm",
				format: "a4",
			});

			const pageWidth = doc.internal.pageSize.getWidth();

			doc.setFont("helvetica", "bold");
			doc.setFontSize(14);
			doc.text("TOKEN AKTIVASI NOTIFIKASI PRESENSI SKAPSA", pageWidth / 2, 15, {
				align: "center",
			});

			const rows = this.generatedTokens.map((data, index) => (data = { ...data, no: index + 1, expires_at: this.toWIB(data.expires_at) }));

			autoTable(doc, {
				startY: 25,
				columns: tableColumns,
				body: rows,

				columnStyles: columns.reduce((styles, column) => {
					styles[column.dataKey] = {
						font: column.font || "helvetica",
						halign: column.align || "center",
					};

					return styles;
				}, {}),

				styles: {
					fontSize: 8,
					cellPadding: 2,
					overflow: "linebreak",
					valign: "middle",
					lineColor: [180, 180, 180],
					lineWidth: 0.2,
				},

				headStyles: {
					fillColor: [41, 128, 185],
					textColor: [255, 255, 255],

					fontStyle: "bold",
					fontSize: 9,

					halign: "center",
					valign: "middle",

					lineColor: [30, 90, 130],
					lineWidth: 0.3,
				},

				bodyStyles: {
					valign: "middle",
					lineColor: [200, 200, 200],
					lineWidth: 0.2,
				},
			});

			let fileName = "TokenAktivasi";
			if (this.formToken.type === "guru") fileName += "Guru.pdf";
			else if (this.formToken.type === "karyawan") fileName += "TenagaKependidikan.pdf";
			else if (this.formToken.type === "siswa") fileName += `Siswa_${this.listRombel.find((r) => r.rombel_id === this.formToken.rombel_id).nama}.pdf`;
			else if (this.formToken.type === "non-gtk") fileName += "NonGTK.pdf";
			else fileName += ".pdf";

			doc.save(fileName);
		},
		async sendTestNotification() {
			this.sendingNotification = true;
			try {
				const { data } = await this.$defaultApi.post("/push/test-notification", {
					push_subscription_id: this.formTestNotify.push_subscription_id,
					title: this.formTestNotify.title,
					body: this.formTestNotify.body,
					type: this.formTestNotify.type,
				});

				this.$notify.success({
					title: "Berhasil",
					message: data.data.message,
				});
			} catch (error) {
				if (error.response) {
					console.error(error.response.data);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
				this.$notify.warning({
					title: "Perhatian",
					message: error.message,
				});
			} finally {
				setTimeout(() => {
					this.sendingNotification = false;
				}, 500);
			}
		},
	},
};
</script>

<style scoped>
.device-option {
	padding: 6px 0;
	line-height: 1.4;
}

.device-label {
	font-size: 14px;
	font-weight: 500;
	color: #303133;
}

.subscription-detail {
	margin-top: 2px;
	font-size: 12px;
	color: #909399;
	white-space: normal;
	line-height: 18px;
}

.el-select-dropdown__item {
	height: auto !important;
}
</style>
